import { Address } from '~/service'
import { removeNulls } from '.'

/**
 * Append a path string to a URL, ensuring that we don't end up with multiple
 * path separators.
 */
export function concatURL(URL: string, ...paths: string[]) {
  return [
    URL.replace(/\/$/, ''),
    ...paths
      .filter((p) => !!p)
      .map((p) => p.replace(/^\//, '').replace(/\/$/, '')),
  ].join('/')
}

/**
 * Get the folder at a specific index in a URL path (or any string with `/`
 * separators).
 */
export function getPathFolderByIndex(pathname: string, index: number) {
  const folders = pathname.split('/')

  if (folders.length <= index) return undefined
  else return folders[index]
}

/**
 * Generate a Google Maps URL for a given address.
 */
export function googleMapsLink(address: Address) {
  const query = [
    address.addressLines?.join(' '),
    address.city,
    address.state,
    address.postalCode,
  ]
    .filter(removeNulls)
    .join(',')

  return `https://www.google.com/maps/search/?api=1&q=${query}`
}

export interface PDFViewerOptions {
  /** Whether to show the toolbar (0 = hide, 1 = show) */
  toolbar?: 0 | 1
  /** Whether to show navigation panes (0 = hide, 1 = show) */
  navpanes?: 0 | 1
  /** Zoom level as a percentage */
  zoom?: number
}

/**
 * Add PDF viewer parameters to a PDF URL to control the display options.
 * This function does not try to determine if the URL points to a PDF file in
 * case the URL is to a website that might accept PDF viewer parameters.
 */
export const addPDFViewerParams = (
  url: string,
  options: PDFViewerOptions = {}
): string => {
  const { toolbar = 0, navpanes = 0, zoom = 100 } = options

  const params = `toolbar=${toolbar}&navpanes=${navpanes}&zoom=${zoom}`

  // Check if URL already has hash parameters
  if (url.includes('#')) {
    // Append to existing hash with &
    return `${url}&${params}`
  } else {
    // Add new hash parameters
    return `${url}#${params}`
  }
}
